module.exports = __webpack_public_path__ + "img/danielfieldschmidt.57bb5c69.jpg";